import { render, staticRenderFns } from "./NestedMenuTabButton.vue?vue&type=template&id=72c86d36&scoped=true&"
import script from "./NestedMenuTabButton.vue?vue&type=script&lang=js&"
export * from "./NestedMenuTabButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c86d36",
  null
  
)

export default component.exports